export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  ERROR: 400,
  UNAUTHORIZED: 401,
};
